// src/utils/translations.js
export const translations = {
  en: {
    seo: {
      titles: {
        home: 'Triarani - Professional Digital Solutions & Technology Services',
        services: 'Our Services - Full Stack Development, Server Management & Digital Marketing',
        projects: 'Our Projects - Successful Digital Solutions Portfolio',
        about: 'About Us - Your Trusted Technology Partner',
        contact: 'Contact Us - Start Your Digital Transformation Journey'
      },
      descriptions: {
        home: 'Expert digital solutions including full stack development, server management, network support, and SEO services. Transform your business with our technology expertise.',
        services: 'Comprehensive technology services: web development, mobile apps, cloud infrastructure, server management, and digital marketing strategies.',
        projects: 'Explore our portfolio of successful projects including corporate websites, e-commerce platforms, mobile applications, and cloud solutions.',
        about: 'Learn about Triarani - professional team with 15+ years experience in delivering cutting-edge digital solutions for businesses.',
        contact: 'Get in touch with our team to discuss your project requirements and start your digital transformation journey today.'
      },
      keywords: 'digital solutions, web development, mobile apps, server management, SEO, digital marketing, cloud services, technology partner'
    },
    nav: {
      home: 'Home',
      services: 'Services',
      projects: 'Projects',
      about: 'About',
      contact: 'Contact',
      getStarted: 'Get Started',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode'
    },
    hero: {
      badge: 'Professional Digital Solutions',
      title: {
        beforeHighlight: 'Transform Your Business with',
        highlight: 'Expert Tech Solutions',
        afterHighlight: ''
      },
      description: 'We deliver cutting-edge applications, robust server infrastructure, and digital marketing strategies that drive growth. From concept to deployment, we\'re your trusted technology partner.',
      buttons: {
        primary: 'Start Your Project',
        secondary: 'Explore Services'
      },
      stats: {
        projects: '50+',
        projectsLabel: 'Projects Delivered',
        experience: '15+',
        experienceLabel: 'Years Experience',
        satisfaction: '98%',
        satisfactionLabel: 'Client Satisfaction'
      }
    },
    services: {
      header: {
        badge: 'What We Offer',
        title: 'Comprehensive Tech Solutions',
        description: 'From development to deployment, we provide end-to-end technology services tailored to your business needs.'
      },
      services: {
        fullStack: {
          title: 'Full Stack Development',
          description: 'Expert web and mobile app development using Laravel, .NET, Django, Node.js, and Flutter. From design to deployment.',
          features: ['Web Applications', 'Mobile Apps (Flutter)', 'Desktop Applications', 'API Integration', 'Maintenance & Optimization']
        },
        serverAdmin: {
          title: 'Server Management',
          description: 'Professional server management services including 24/7 monitoring, cloud infrastructure, and DevOps solutions for scalable, secure systems.',
          features: ['24/7 Server Monitoring', 'AWS & Cloud Management', 'Docker & Kubernetes', 'Security & Backup', 'Performance Optimization']
        },
        networkSupport: {
          title: 'Network & Tech Support',
          description: 'Professional network setup, CCTV installation, and comprehensive technical support for businesses.',
          features: ['Network Setup', 'CCTV Installation', 'Troubleshooting', 'Remote Support', 'Onsite Services']
        },
        seoMarketing: {
          title: 'SEO & Digital Marketing',
          description: 'Data-driven SEO strategies and digital marketing campaigns to boost your online presence and drive growth.',
          features: ['SEO Optimization', 'Traffic Growth', 'Performance Analysis', 'Content Strategy', 'Business Growth']
        }
      },
      learnMore: 'Learn More',
      cta: {
        title: 'Ready to Transform Your Business?',
        description: 'Let\'s discuss how our comprehensive tech solutions can drive your business forward.',
        buttons: {
          primary: 'Start Your Project',
          secondary: 'View Our Work'
        }
      }
    },
    projects: {
      header: {
        badge: 'Portfolio',
        title: 'Projects That Deliver Results',
        description: 'We\'ve partnered with leading companies to deliver innovative digital solutions across various industries.'
      },
      categories: {
        corporate: {
          title: 'Corporate Websites',
          description: 'Professional corporate websites with modern design and functionality',
          items: ['Mobiliarigroup', 'Tostem Indonesia', 'Jalin', 'Celebrity Fitness']
        },
        ecommerce: {
          title: 'E-Commerce',
          description: 'Full-featured online stores with payment integration and inventory management',
          items: ['SuperLife', 'AutoGlaze']
        },
        mobile: {
          title: 'Mobile Applications',
          description: 'Cross-platform mobile apps built with Flutter for iOS and Android',
          items: ['HiHome', 'Jas Merah', 'AutoGlaze App']
        },
        cloud: {
          title: 'Cloud Platforms',
          description: 'Scalable cloud-based platforms with robust infrastructure management',
          items: ['Solid Bergerak', 'CrowdLab']
        },
        network: {
          title: 'Network Solutions',
          description: 'Enterprise network setup and IT infrastructure management',
          items: ['Redcomm', 'Rekajasa Asyatama']
        }
      },
      stats: {
        projects: '50+',
        projectsLabel: 'Projects Completed',
        clients: '25+',
        clientsLabel: 'Happy Clients',
        industries: '15+',
        industriesLabel: 'Industries Served',
        experience: '15+',
        experienceLabel: 'Years Experience'
      },
      cta: {
        description: 'Want to see more of our work or start your own project?',
        buttons: {
          primary: 'Let\'s Discuss Your Project',
          secondary: 'Explore Our Services'
        }
      }
    },
    about: {
      header: {
        badge: 'Why Choose Us',
        title: 'Your Trusted Technology Partner',
        description: 'We are a professional team specializing in application development, server management, and digital marketing. Our mission is to help businesses embrace modern, efficient, and scalable digital solutions.'
      },
      features: {
        expertTeam: {
          title: 'Expert Team',
          description: 'Professional developers and engineers with international project experience'
        },
        customSolutions: {
          title: 'Custom Solutions',
          description: 'Tailored digital solutions designed to fit your specific business needs and budget'
        },
        endToEndSupport: {
          title: 'End-to-End Support',
          description: 'Comprehensive technical support from initial planning through to implementation'
        },
        longTermPartnership: {
          title: 'Long-Term Partnership',
          description: 'Ongoing maintenance, analysis, and development for sustained growth'
        }
      },
      stats: {
        projects: {
          label: 'Projects Completed',
          value: '50+'
        },
        experience: {
          label: 'Years Experience',
          value: '15+'
        },
        satisfaction: {
          label: 'Client Satisfaction',
          value: '98%'
        },
        retention: {
          label: 'Retention Rate',
          value: '95%'
        }
      },
      valueProposition: {
        title: 'Delivering Excellence Since Day One',
        description: {
          part1: 'With over 15 years of experience in the industry, we\'ve successfully delivered 50+ projects for clients ranging from startups to large enterprises. Our expertise spans across web development, mobile applications, cloud infrastructure management, and digital marketing strategies.',
          part2: 'We don\'t just build software—we create solutions that drive business growth, improve efficiency, and deliver measurable results. Our commitment to quality and client satisfaction has earned us a 98% client retention rate.'
        },
        additionalInfo: [
          'Agile Development',
          'Quality Assurance',
          'Continuous Support',
          'Security Focused'
        ],
        metrics: [
          { label: 'Code Quality', value: 95, color: 'from-blue-500 to-blue-600' },
          { label: 'Client Satisfaction', value: 98, color: 'from-green-500 to-green-600' },
          { label: 'On-Time Delivery', value: 92, color: 'from-purple-500 to-purple-600' },
          { label: 'Project Success Rate', value: 96, color: 'from-orange-500 to-orange-600' }
        ]
      },
      cta: {
        title: 'Ready to Start Your Project?',
        description: 'Let\'s discuss how we can help transform your business with our expert technology solutions.',
        buttons: {
          primary: 'Get Started Today',
          secondary: 'View Our Work'
        }
      }
    },
    contact: {
      header: {
        badge: 'Get In Touch',
        title: 'Let\'s Build Something Amazing',
        description: 'Ready to transform your business with technology? Contact us today for a free consultation.'
      },
      contactSection: {
        title: 'Contact Information',
        description: 'Have a project in mind? We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.'
      },
      contactInfo: {
        email: {
          label: 'Email',
          value: 'edwin@triarani.com'
        },
        phone: {
          label: 'Mobile',
          value: '+62 815 875 1506'
        },
        website: {
          label: 'Website',
          value: 'www.triarani.com'
        },
        location: {
          label: 'Location',
          value: 'Indonesia'
        }
      },
      additionalInfo: {
        responseTime: {
          title: 'Response Time',
          description: 'We typically respond within 2-4 hours during business hours.'
        },
        businessHours: {
          title: 'Business Hours',
          hours: [
            { day: 'Monday - Friday', time: '9:00 AM - 6:00 PM' },
            { day: 'Saturday', time: '10:00 AM - 4:00 PM' },
            { day: 'Sunday', time: 'Closed' }
          ]
        }
      },
      form: {
        fields: {
          name: {
            label: 'Full Name',
            placeholder: 'John Doe'
          },
          email: {
            label: 'Email',
            placeholder: 'john@example.com'
          },
          phone: {
            label: 'Phone',
            placeholder: '+62 812 3456 7890'
          },
          service: {
            label: 'Service Interested In',
            placeholder: 'Select a service',
            options: [
              'Full Stack Development',
              'Server Management',
              'Network & Tech Support',
              'SEO & Digital Marketing',
              'Other'
            ]
          },
          message: {
            label: 'Message',
            placeholder: 'Tell us about your project...'
          }
        },
        error: 'An error occurred. Please try again or send email directly to edwin@triarani.com',
        submitButton: 'Send Message',
        success: {
          title: 'Thank You!',
          description: 'Your message has been sent successfully. We\'ll get back to you soon.'
        }
      }
    },
    footer: {
      companyInfo: {
        description: 'Professional team specializing in application development, server management, and digital marketing. Transforming businesses with cutting-edge technology solutions.',
        location: 'Indonesia'
      },
      sections: {
        quickLinks: 'Quick Links',
        services: 'Services',
        contact: 'Contact'
      },
      links: {
        services: 'Services',
        projects: 'Projects',
        about: 'About',
        contact: 'Contact'
      },
      services: {
        fullStack: 'Full Stack Development',
        serverAdmin: 'Server Management',
        networkSupport: 'Network Support',
        seoMarketing: 'SEO & Marketing'
      },
      contactInfo: {
        email: 'edwin@triarani.com',
        phone: '+62 815 875 1506',
        website: 'www.triarani.com'
      },
      copyright: '©',
      rightsReserved: 'All rights reserved.',
      credits: 'Edwin Arifin - Full Stack Developer & Technology Specialist',
      scrollToTop: 'Scroll to top'
    }
  },
  id: {
    seo: {
      titles: {
        home: 'Triarani - Solusi Digital Profesional & Layanan Teknologi',
        services: 'Layanan Kami - Pengembangan Full Stack, Manajemen Server & Pemasaran Digital',
        projects: 'Proyek Kami - Portfolio Solusi Digital yang Sukses',
        about: 'Tentang Kami - Partner Teknologi Terpercaya Anda',
        contact: 'Hubungi Kami - Mulai Perjalanan Transformasi Digital Anda'
      },
      descriptions: {
        home: 'Solusi digital ahli termasuk pengembangan full stack, manajemen server, dukungan jaringan, dan layanan SEO. Transformasi bisnis Anda dengan keahlian teknologi kami.',
        services: 'Layanan teknologi komprehensif: pengembangan web, aplikasi mobile, infrastruktur cloud, manajemen server, dan strategi pemasaran digital.',
        projects: 'Jelajahi portfolio proyek sukses kami termasuk website perusahaan, platform e-commerce, aplikasi mobile, dan solusi cloud.',
        about: 'Pelajari tentang Triarani - tim profesional dengan pengalaman 15+ tahun dalam memberikan solusi digital terkini untuk bisnis.',
        contact: 'Hubungi tim kami untuk mendiskusikan kebutuhan proyek Anda dan mulai perjalanan transformasi digital hari ini.'
      },
      keywords: 'solusi digital, pengembangan web, aplikasi mobile, manajemen server, SEO, pemasaran digital, layanan cloud, partner teknologi'
    },
    nav: {
      home: 'Beranda',
      services: 'Layanan',
      projects: 'Proyek',
      about: 'Tentang',
      contact: 'Kontak',
      getStarted: 'Mulai Sekarang',
      lightMode: 'Mode Terang',
      darkMode: 'Mode Gelap'
    },
    hero: {
      badge: 'Solusi Digital Profesional',
      title: {
        beforeHighlight: 'Transformasi Bisnis Anda dengan',
        highlight: 'Solusi Teknologi Ahli',
        afterHighlight: ''
      },
      description: 'Kami menghadirkan aplikasi terkini, infrastruktur server yang tangguh, dan strategi pemasaran digital yang mendorong pertumbuhan. Dari konsep hingga implementasi, kami adalah partner teknologi terpercaya Anda.',
      buttons: {
        primary: 'Mulai Proyek Anda',
        secondary: 'Jelajahi Layanan'
      },
      stats: {
        projects: '50+',
        projectsLabel: 'Proyek Diselesaikan',
        experience: '15+',
        experienceLabel: 'Tahun Pengalaman',
        satisfaction: '98%',
        satisfactionLabel: 'Kepuasan Klien'
      }
    },
    services: {
      header: {
        badge: 'Layanan Kami',
        title: 'Solusi Teknologi Komprehensif',
        description: 'Dari pengembangan hingga implementasi, kami menyediakan layanan teknologi end-to-end yang disesuaikan dengan kebutuhan bisnis Anda.'
      },
      services: {
        fullStack: {
          title: 'Pengembangan Full Stack',
          description: 'Pengembangan web dan aplikasi mobile ahli menggunakan Laravel, .NET, Django, Node.js, dan Flutter. Dari desain hingga implementasi.',
          features: ['Aplikasi Web', 'Aplikasi Mobile (Flutter)', 'Aplikasi Desktop', 'Integrasi API', 'Pemeliharaan & Optimasi']
        },
        serverAdmin: {
          title: 'Manajemen Server',
          description: 'Layanan manajemen server profesional termasuk monitoring 24/7, infrastruktur cloud, dan solusi DevOps untuk sistem yang scalable dan aman.',
          features: ['Monitoring Server 24/7', 'Manajemen AWS & Cloud', 'Docker & Kubernetes', 'Keamanan & Backup', 'Optimasi Performa']
        },
        networkSupport: {
          title: 'Jaringan & Dukungan Teknis',
          description: 'Setup jaringan profesional, instalasi CCTV, dan dukungan teknis komprehensif untuk bisnis.',
          features: ['Setup Jaringan', 'Instalasi CCTV', 'Troubleshooting', 'Dukungan Remote', 'Layanan Onsite']
        },
        seoMarketing: {
          title: 'SEO & Pemasaran Digital',
          description: 'Strategi SEO berbasis data dan kampanye pemasaran digital untuk meningkatkan kehadiran online dan mendorong pertumbuhan.',
          features: ['Optimasi SEO', 'Pertumbuhan Traffic', 'Analisis Performa', 'Strategi Konten', 'Pertumbuhan Bisnis']
        }
      },
      learnMore: 'Pelajari Lebih Lanjut',
      cta: {
        title: 'Siap Transformasi Bisnis Anda?',
        description: 'Mari diskusikan bagaimana solusi teknologi komprehensif kami dapat memajukan bisnis Anda.',
        buttons: {
          primary: 'Mulai Proyek Anda',
          secondary: 'Lihat Portfolio Kami'
        }
      }
    },
    projects: {
      header: {
        badge: 'Portfolio',
        title: 'Proyek yang Memberikan Hasil',
        description: 'Kami telah bermitra dengan perusahaan terkemuka untuk memberikan solusi digital inovatif di berbagai industri.'
      },
      categories: {
        corporate: {
          title: 'Website Perusahaan',
          description: 'Website perusahaan profesional dengan desain modern dan fungsionalitas lengkap',
          items: ['Mobiliarigroup', 'Tostem Indonesia', 'Jalin', 'Celebrity Fitness']
        },
        ecommerce: {
          title: 'E-Commerce',
          description: 'Toko online lengkap dengan integrasi pembayaran dan manajemen inventori',
          items: ['SuperLife', 'AutoGlaze']
        },
        mobile: {
          title: 'Aplikasi Mobile',
          description: 'Aplikasi mobile cross-platform yang dibangun dengan Flutter untuk iOS dan Android',
          items: ['HiHome', 'Jas Merah', 'AutoGlaze App']
        },
        cloud: {
          title: 'Platform Cloud',
          description: 'Platform berbasis cloud yang scalable dengan manajemen infrastruktur yang tangguh',
          items: ['Solid Bergerak', 'CrowdLab']
        },
        network: {
          title: 'Solusi Jaringan',
          description: 'Setup jaringan enterprise dan manajemen infrastruktur IT',
          items: ['Redcomm', 'Rekajasa Asyatama']
        }
      },
      stats: {
        projects: '50+',
        projectsLabel: 'Proyek Diselesaikan',
        clients: '25+',
        clientsLabel: 'Klien Bahagia',
        industries: '15+',
        industriesLabel: 'Industri Dilayani',
        experience: '15+',
        experienceLabel: 'Tahun Pengalaman'
      },
      cta: {
        description: 'Ingin melihat lebih banyak karya kami atau memulai proyek Anda sendiri?',
        buttons: {
          primary: 'Diskusikan Proyek Anda',
          secondary: 'Jelajahi Layanan Kami'
        }
      }
    },
    about: {
      header: {
        badge: 'Mengapa Memilih Kami',
        title: 'Partner Teknologi Terpercaya Anda',
        description: 'Kami adalah tim profesional yang mengkhususkan diri dalam pengembangan aplikasi, manajemen server, dan pemasaran digital. Misi kami adalah membantu bisnis mengadopsi solusi digital yang modern, efisien, dan scalable.'
      },
      features: {
        expertTeam: {
          title: 'Tim Ahli',
          description: 'Developer dan engineer profesional dengan pengalaman proyek internasional'
        },
        customSolutions: {
          title: 'Solusi Kustom',
          description: 'Solusi digital yang disesuaikan dengan kebutuhan bisnis spesifik dan anggaran Anda'
        },
        endToEndSupport: {
          title: 'Dukungan End-to-End',
          description: 'Dukungan teknis komprehensif dari perencanaan awal hingga implementasi'
        },
        longTermPartnership: {
          title: 'Kemitraan Jangka Panjang',
          description: 'Pemeliharaan berkelanjutan, analisis, dan pengembangan untuk pertumbuhan yang berkelanjutan'
        }
      },
      stats: {
        projects: {
          label: 'Proyek Diselesaikan',
          value: '50+'
        },
        experience: {
          label: 'Tahun Pengalaman',
          value: '15+'
        },
        satisfaction: {
          label: 'Kepuasan Klien',
          value: '98%'
        },
        retention: {
          label: 'Tingkat Retensi',
          value: '95%'
        }
      },
      valueProposition: {
        title: 'Memberikan Keunggulan Sejak Hari Pertama',
        description: {
          part1: 'Dengan pengalaman lebih dari 15 tahun di industri, kami telah berhasil menyelesaikan 50+ proyek untuk klien mulai dari startup hingga perusahaan besar. Keahlian kami mencakup pengembangan web, aplikasi mobile, manajemen infrastruktur cloud, dan strategi pemasaran digital.',
          part2: 'Kami tidak hanya membangun perangkat lunak—kami menciptakan solusi yang mendorong pertumbuhan bisnis, meningkatkan efisiensi, dan memberikan hasil yang terukur. Komitmen kami terhadap kualitas dan kepuasan klien telah menghasilkan tingkat retensi klien 98%.'
        },
        additionalInfo: [
          'Pengembangan Agile',
          'Jaminan Kualitas',
          'Dukungan Berkelanjutan',
          'Fokus Keamanan'
        ],
        metrics: [
          { label: 'Kualitas Kode', value: 95, color: 'from-blue-500 to-blue-600' },
          { label: 'Kepuasan Klien', value: 98, color: 'from-green-500 to-green-600' },
          { label: 'Pengiriman Tepat Waktu', value: 92, color: 'from-purple-500 to-purple-600' },
          { label: 'Tingkat Kesuksesan Proyek', value: 96, color: 'from-orange-500 to-orange-600' }
        ]
      },
      cta: {
        title: 'Siap Memulai Proyek Anda?',
        description: 'Mari diskusikan bagaimana kami dapat membantu mentransformasi bisnis Anda dengan solusi teknologi ahli kami.',
        buttons: {
          primary: 'Mulai Sekarang',
          secondary: 'Lihat Karya Kami'
        }
      }
    },
    contact: {
      header: {
        badge: 'Hubungi Kami',
        title: 'Mari Bangun Sesuatu yang Menakjubkan',
        description: 'Siap mentransformasi bisnis Anda dengan teknologi? Hubungi kami hari ini untuk konsultasi gratis.'
      },
      contactSection: {
        title: 'Informasi Kontak',
        description: 'Punya proyek dalam pikiran? Kami ingin mendengar dari Anda. Kirim pesan dan kami akan merespons secepatnya.'
      },
      contactInfo: {
        email: {
          label: 'Email',
          value: 'edwin@triarani.com'
        },
        phone: {
          label: 'Telepon',
          value: '+62 815 875 1506'
        },
        website: {
          label: 'Website',
          value: 'www.triarani.com'
        },
        location: {
          label: 'Lokasi',
          value: 'Indonesia'
        }
      },
      additionalInfo: {
        responseTime: {
          title: 'Waktu Respon',
          description: 'Kami biasanya merespons dalam 2-4 jam selama jam kerja.'
        },
        businessHours: {
          title: 'Jam Operasional',
          hours: [
            { day: 'Senin - Jumat', time: '09:00 - 18:00' },
            { day: 'Sabtu', time: '10:00 - 16:00' },
            { day: 'Minggu', time: 'Tutup' }
          ]
        }
      },
      form: {
        fields: {
          name: {
            label: 'Nama Lengkap',
            placeholder: 'John Doe'
          },
          email: {
            label: 'Email',
            placeholder: 'john@example.com'
          },
          phone: {
            label: 'Telepon',
            placeholder: '+62 812 3456 7890'
          },
          service: {
            label: 'Layanan yang Diminati',
            placeholder: 'Pilih layanan',
            options: [
              'Pengembangan Full Stack',
              'Manajemen Server',
              'Jaringan & Dukungan Teknis',
              'SEO & Pemasaran Digital',
              'Lainnya'
            ]
          },
          message: {
            label: 'Pesan',
            placeholder: 'Ceritakan tentang proyek Anda...'
          }
        },
        error: 'Terjadi kesalahan. Silakan coba lagi atau kirim email langsung ke edwin@triarani.com',
        submitButton: 'Kirim Pesan',
        success: {
          title: 'Terima Kasih!',
          description: 'Pesan Anda telah berhasil dikirim. Kami akan segera menghubungi Anda kembali.'
        }
      }
    },
    footer: {
      companyInfo: {
        description: 'Tim profesional yang mengkhususkan diri dalam pengembangan aplikasi, manajemen server, dan pemasaran digital. Mentransformasi bisnis dengan solusi teknologi terkini.',
        location: 'Indonesia'
      },
      sections: {
        quickLinks: 'Tautan Cepat',
        services: 'Layanan',
        contact: 'Kontak'
      },
      links: {
        services: 'Layanan',
        projects: 'Proyek',
        about: 'Tentang',
        contact: 'Kontak'
      },
      services: {
        fullStack: 'Pengembangan Full Stack',
        serverAdmin: 'Manajemen Server',
        networkSupport: 'Dukungan Jaringan',
        seoMarketing: 'SEO & Pemasaran'
      },
      contactInfo: {
        email: 'edwin@triarani.com',
        phone: '+62 815 875 1506',
        website: 'www.triarani.com'
      },
      copyright: '©',
      rightsReserved: 'Hak cipta dilindungi.',
      credits: 'Edwin Arifin - Full Stack Developer & Spesialis Teknologi',
      scrollToTop: 'Ke atas'
    }
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'id', name: 'Indonesia', flag: '🇮🇩' }
];